import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import { appUserLevels } from 'global/enums/globalEnums';
import _ from 'lodash';
import { useContext, useEffect, useRef, useState } from 'react';
import { GolfParentContext } from '../cnr/contexts/GolfParentContext';
import { GolfTournamentContext } from '../cnr/contexts/GolfTournamentContext';
import { CreateGolfContext } from '../create/CreateGolf';
import { GolferSquares } from './GolferSquares';
import GolferTeamSelect from './GolferTeamSelect';

const GolfTeams = (props) => {

  const { forList, forSelect } = props

  const appUserAccess = useAppUserAccess()
  const { isSuperAdminDeveloper } = appUserAccess ?? {}

  // golfParentContext 
  const golfParentContext = useContext(GolfParentContext)
  const { golfParent_contexts } = golfParentContext ?? {}
  const { states, fns } = golfParent_contexts ?? {}
  const { golfTournament_state } = states ?? {}
  const { appUser_fns } = fns ?? {}

  // golfTournamentContext - direct
  const golfTournamentContext = useContext(GolfTournamentContext)
  const { golfTournament_state: gts } = golfTournamentContext ? golfTournamentContext : {}

  // const _golfEvent_state = ges ? ges : golfEvent_state
  const _golfTournament_state = gts ? gts : golfTournament_state

  // createGolfContext
  const createGolfContext = useContext(CreateGolfContext);
  const { golfEvent_state, golfCreate_state } = createGolfContext ? createGolfContext : {}

  const forCreate = golfCreate_state ? true : false

  // golfEvent
  const { teams: teams_event } = golfEvent_state ?? {}

  // golfCreate
  const { tournamentDetails, rowIndex } = golfCreate_state ? golfCreate_state : {}
  const { golfers: golfers_details } = tournamentDetails ? tournamentDetails : {}

  // golfTournamentContext   
  const { details, golfStyles } = _golfTournament_state ? _golfTournament_state : {}
  const { golfers: golfers_tournament, teams: teams_tournament } = details ?? {}

  const _teams = teams_tournament ? teams_tournament : teams_event

  const [_golfers, set_golfers] = useState()
  const [golfTeamsInfo, setGolfTeamsInfo] = useState()
  const [scrollToIndex, setScrollToIndex] = useState();

  const allowMods = appUser_fns ? appUser_fns.validateAccess_item(appUserLevels.superAdmin, true) : false

  const scrollRef = useRef(null);

  useEffect(() => {
    let _glfs;
    if (forSelect) {
      set_golfers(golfers_details)
    } else {
      if (golfers_tournament) {
        _glfs = { ...golfers_tournament }
        set_golfers(_glfs)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [golfers_details, golfers_tournament]);

  useEffect(() => {
    if (rowIndex !== null) {
      setScrollToIndex(rowIndex)
    }
  }, [rowIndex]);

  useEffect(() => {
    if (scrollRef && scrollRef.current) {
      if (scrollToIndex) {
        // Scroll the next row into view
        scrollRef.current.children[scrollToIndex].scrollIntoView({
          behavior: 'smooth',
        });

        // Reset the scrollToIndex state after scrolling
        setTimeout(() => {
          setScrollToIndex(null);
        }, 500); // Adjust the delay as needed
      }
    }
  }, [scrollToIndex]);

  useEffect(() => {
    if (_teams && _golfers) {
      let _team1 = _teams ? _.find(_teams, { teamNumber: 1 }) : {}
      let _team2 = _teams ? _.find(_teams, { teamNumber: 2 }) : {}

      if (!_team1) { _team1 = _teams.team1 }
      if (!_team2) { _team2 = _teams.team2 }

      const _golfers_team = _.groupBy(_golfers, 'teamNumber')
      const _golfers_teams = { team1: [], team2: [] }

      if (_golfers_team) {
        Object.keys(_golfers_team).forEach(key => {
          _golfers_teams['team' + key] = _golfers_team[key]
        })
      }

      const _team1Count = _golfers_teams && _golfers_teams.team1 ? _golfers_teams.team1.length : 0
      const _team2Count = _golfers_teams && _golfers_teams.team2 ? _golfers_teams.team2.length : 0

      const _noTeamCount = Object.keys(_golfers).length - (_team1Count + _team2Count)

      setGolfTeamsInfo({ teamz: _golfers_team, team1: _team1, team2: _team2, team1Count: _team1Count, team2Count: _team2Count, noTeamCount: _noTeamCount })
    }
  }, [_teams, _golfers]);

  const content_create = () => {
    return _.map(_.sortBy(_golfers, 'lastName'), golfer => (<GolferTeamSelect golfer={golfer} />))
  }

  const content_tournament = () => <GolferSquares
    golfers={_golfers}
    golfStyles={golfStyles}
    teams={_teams}
    allowMods={allowMods}
  />

  if (forCreate) {
    return content_create()
  }

  return forList ? teamPlayerList() : content_tournament()

}

export default GolfTeams